import { ZoomIn } from 'lucide-react'

interface ExamplePreviewProps {
	onZoomClick: () => void
}

export default function ExamplePreview({ onZoomClick }: ExamplePreviewProps) {
	return (
		<div className="flex items-center gap-4 rounded-lg border border-primary/20 bg-primary/5 p-4">
			<div className="group relative cursor-pointer" onClick={onZoomClick}>
				<img
					src="/src/images/promotion.png"
					alt="ตัวอย่าง"
					className="h-32 w-auto rounded-lg border shadow-sm transition-opacity group-hover:opacity-80"
				/>
				<div className="absolute inset-0 flex items-center justify-center rounded-lg bg-black/50 opacity-0 transition-opacity group-hover:opacity-100">
					<ZoomIn className="h-8 w-8 text-white" />
				</div>
			</div>
			<div className="flex-1">
				<p className="mb-1 text-sm font-medium text-primary">
					💡 ตัวอย่างข้อความ Flex Message
				</p>
				<p className="text-sm text-muted-foreground">
					ข้อความจะถูกส่งไปยัง LINE ของผู้เล่นในรูปแบบ Flex Message
					พร้อมรายการโบนัส/โปรโมชันและปุ่มกดรับได้ทันที
				</p>
				<button
					type="button"
					onClick={onZoomClick}
					className="mt-2 text-xs text-primary underline-offset-2 hover:underline"
				>
					คลิกเพื่อดูภาพขนาดใหญ่
				</button>
			</div>
		</div>
	)
}
